import '../i18n/autoTranslate';
import React, { useState } from 'react';
import SpotlightCard from '../../components/ui/SpotlightCard';
import { RiCloseCircleFill } from 'react-icons/ri';

const DemoPreviewModal = ({isOpen, setIsOpen}) => {
  
  return (
    <div 
      style={{zIndex: 999999999}}
      className={`${isOpen ? 'fixed' : 'hidden'} inset-0 bg-black/70 backdrop-blur-md z-50 flex items-center justify-center p-4`}
      onClick={(e) => {
        if (e.target === e.currentTarget) setIsOpen(false);
      }}
    >
      <SpotlightCard
        className="custom-spotlight-card w-full max-w-4xl"
        spotlightColor="rgba(255, 150, 0, 0.1)"
      >
        <div className="relative bg-[rgba(30,30,46,0.95)] rounded-2xl border border-white/10 hover:border-purple-500/30 transition-all duration-200 overflow-hidden">
          {/* Close Button - Better positioned */}
          <button 
            onClick={() => setIsOpen(false)}
            className="absolute top-3 right-3 z-20 cursor-pointer hover:scale-110 hover:text-pink-400 transition-all duration-200 bg-black/50 rounded-full p-1"
            aria-label="Close modal"
          >
            <RiCloseCircleFill size={28} className="text-white/80 hover:text-pink-400" />
          </button>
          
          {/* Video Container */}
          <div className="relative w-full bg-black">
            <video 
              src="/demo.mp4" 
              autoPlay 
              controls
              loop
              muted={false}
              playsInline
              className="w-full h-auto max-h-[80vh] object-contain"
            >
              Your browser does not support the video tag.
            </video>
          </div>
          
          {/* Optional Video Caption/Label */}
          <div className="absolute bottom-3 left-3 z-20 bg-black/50 backdrop-blur-sm px-3 py-1 rounded-full">
            <span className="text-white/70 text-xs">Demo Preview</span>
          </div>
        </div>      
      </SpotlightCard>
    </div>
  );
};

export default DemoPreviewModal;
